import { TYPES } from "../actions";

const initialState = {
  albums: [],
  totalCount: 0,
  currentAlbum: null,
  loading: false
};

export const tkt1ImageAlbumReducer = (state = initialState, action) => {
  switch (action.type) {

    case TYPES.ACTION_GET_TKT1_IMAGE_ALBUMS_SUCCESS:
      return { 
        ...state, 
        albums: action.payload.data.albums || [], 
        totalCount: action.payload.data.pagination?.totalItems || 0,
        loading: false
      };

    case TYPES.ACTION_GET_TKT1_IMAGE_ALBUMS_FAIL:
      return { 
        ...state, 
        albums: [],
        loading: false
      };

    case TYPES.ACTION_GET_TKT1_IMAGE_ALBUM_BY_ID_SUCCESS:
      return { 
        ...state, 
        currentAlbum: action.payload.data,
        loading: false
      };

    case TYPES.ACTION_GET_TKT1_IMAGE_ALBUM_BY_ID_FAIL:
      return { 
        ...state, 
        currentAlbum: null,
        loading: false
      };

    case TYPES.ACTION_GET_TKT1_IMAGE_ALBUM_BY_MID_SUCCESS:
      return { 
        ...state, 
        currentAlbum: action.payload.data,
        loading: false
      };

    case TYPES.ACTION_GET_TKT1_IMAGE_ALBUM_BY_MID_FAIL:
      return { 
        ...state, 
        currentAlbum: null,
        loading: false
      };

    case TYPES.ACTION_CREATE_TKT1_IMAGE_ALBUM_SUCCESS:
      return { 
        ...state, 
        albums: [action.payload.data, ...state.albums],
        totalCount: state.totalCount + 1,
        loading: false
      };

    case TYPES.ACTION_CREATE_TKT1_IMAGE_ALBUM_FAIL:
      return { 
        ...state, 
        loading: false
      };

    case TYPES.ACTION_UPDATE_TKT1_IMAGE_ALBUM_SUCCESS:
      return { 
        ...state, 
        albums: state.albums.map(album => 
          album._id === action.payload.data._id ? action.payload.data : album
        ),
        currentAlbum: state.currentAlbum && state.currentAlbum._id === action.payload.data._id 
          ? action.payload.data 
          : state.currentAlbum,
        loading: false
      };

    case TYPES.ACTION_UPDATE_TKT1_IMAGE_ALBUM_FAIL:
      return { 
        ...state, 
        loading: false
      };

    case TYPES.ACTION_DELETE_TKT1_IMAGE_ALBUM_SUCCESS:
      return { 
        ...state, 
        albums: state.albums.filter(album => album._id !== action.payload.id),
        totalCount: Math.max(0, state.totalCount - 1),
        currentAlbum: state.currentAlbum && state.currentAlbum._id === action.payload.id 
          ? null 
          : state.currentAlbum,
        loading: false
      };

    case TYPES.ACTION_DELETE_TKT1_IMAGE_ALBUM_FAIL:
      return { 
        ...state, 
        loading: false
      };
      
    default:
      return state;
  }
};
